import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    admin: "",
    whichToShow: "bingo",

    adminURL: "",
    bingoAdminURL: "https://cartela.arkisports5.com/graphql",
  },
  getters: {},
  mutations: {
    loginAdmin(state, admin) {
      state.admin = admin;
    },

    wichToSwitch(state, whichToShow) {
      state.whichToShow = whichToShow;
    },
    dogURL(state, dogURL) {
      state.bingoAdminURL = dogURL;
    },
  },
  actions: {
    loginAdmin(context, admin) {
      context.commit("loginAdmin", admin);
    },

    wichToSwitch(context, whichToShow) {
      context.commit("wichToSwitch", whichToShow);
    },
    dogURL(context, dogURL) {
      context.commit("dogURL", dogURL);
    },
  },

  plugins: [createPersistedState()],
  modules: {},
});
